export const ru = {
    female: 'Женский',
    male: 'Мужской',
};
